export default [
  {
    header: 'Chantiers',
    rights: [
      'CHANTIER:read',
    ],
  },
  {
    title: "Projets d'amélioration",
    icon: 'LayersIcon',
    route: { name: 'chantiers-projets-list' },
    rights: [
      'CHANTIER:read',
    ],
  },
  {
    title: 'Chantiers qualité',
    icon: 'ClipboardIcon',
    route: { name: 'chantiers-list' },
    rights: [
      'CHANTIER:read',
    ],
  },
  {
    title: 'Récap des chantiers',
    icon: 'ColumnsIcon',
    route: { name: 'chantiers-recap-public' },
    rights: [
      'CHANTIER:read',
    ],
  },
  {
    title: 'Bulletin de synthèse',
    icon: 'FileTextIcon',
    route: { name: 'chantiers-bulletin' },
    rights: [
      'CHANTIER:read',
    ],
  },
  {
    title: 'Catégories chantiers',
    icon: 'TagIcon',
    route: { name: 'chantiers-admin-categories' },
    rights: [
      'CHANTIER:admin',
    ],
  },
  {
    title: 'Origines chantiers',
    icon: 'GitBranchIcon',
    route: { name: 'chantiers-admin-origines' },
    rights: [
      'CHANTIER:admin',
    ],
  },
  {
    title: 'Chantiers archivés',
    icon: 'ArchiveIcon',
    route: { name: 'chantiers-admin-archived' },
    rights: [
      'CHANTIER:admin',
    ],
  },
]
